angular.module("app").controller("AndroidAppSkinningController", [
    '$scope',
    '$timeout',
    '$filter',
    'settingsService',
    'appTypes',
    'androidAppService',
    "preloadedData",
    "logger",
    "errorHandler",
    "Utils",
    function ($scope, $timeout, $filter, settingsService, appTypes, androidAppService, preloadedData, logger, errorHandler, Utils) {
        var settings = settingsService.getSettings();
        $scope.appTypes = appTypes;

        $scope.skinId = settings.skin.id;
        $scope.skinName = settings.skin.name;
        $scope.defaultLang = $filter("translate")('top_menu.languages.' + settings.skin.defaultLang);
        $scope.launcherLogo = {};
        $scope.appMainLogo = {};
        $scope.lastUpdate = "";
        preloadedData && convertResponse(preloadedData);

        function load(response) {
            var data = response && response[$scope.selectedType];

            if (data && data["launcher_logo"]) {
                $scope.launcherLogo.image = data["launcher_logo"].image;
            } else {
                $scope.launcherLogo.image = undefined;
            }
            if (data && data["main_logo"]) {
                $scope.appMainLogo.image = data["main_logo"].image;
            } else {
                $scope.appMainLogo.image = undefined;
            }
            $scope.app_id = data && data['app_id'];
            $scope.lastUpdate = data && data.last_update;

        }

        /**
         * Convert response dates into given format
         * @param response
         */
        function convertResponse(response) {
            appTypes.forEach(function (key) {
                if (response[key] && response[key].last_update) {
                    response[key].last_update = $filter("convertDateToUserTimezone")(response[key].last_update, null, 'DD-MM-YYYY hh:mm A');
                }
            })
        }

        /**
         * Update logos and last update
         * @param response
         */
        function update(response) {
            load(response);
            $scope.launcherLogo.update();
            $scope.appMainLogo.update();
            $scope.analytical_json = undefined;
        }

        /**
         * Select given type update images and last update
         * @param type
         */
        $scope.selectType = function selectType(type, isFirstTime) {
            if ($scope.selectedType !== type) {
                $scope.selectedType = type;
                if (isFirstTime) {
                    load(preloadedData);
                } else {
                    update(preloadedData);
                }
            }

        };
        $scope.selectType(appTypes[0], true);

        /**
         * Send images into backend
         */
        $scope.publish = function publish() {
            $scope.launcherLogo.buildResult(function (launcherLogoData) {
                if(launcherLogoData && launcherLogoData.requiredError) {
                    return;
                }
                $scope.appMainLogo.buildResult(function (appMainLogoData) {
                    var requestData = {};
                    launcherLogoData && (requestData.launcher_logo = launcherLogoData);
                    appMainLogoData && (requestData.main_logo = appMainLogoData);
                    requestData.type = $scope.selectedType;
                    $scope.analytical_json && (requestData.analytical_json = $scope.analytical_json);
                    androidAppService.saveData(requestData).then(function (response) {
                            if (response.status === "ok") {
                                logger.logSuccess("global.successfullyPublished");
                                androidAppService.loadData().then(function (loadingResponse) {
                                    if (loadingResponse.status === 'ok') {
                                        loadingResponse = angular.copy(loadingResponse);
                                        convertResponse(loadingResponse.data);
                                        preloadedData = loadingResponse.data;
                                        update(preloadedData);
                                    }

                                }, function (failResponse) {
                                    errorHandler(failResponse.message)
                                })
                            } else {
                                errorHandler(response.message)
                            }
                        },
                        function (response) {
                            errorHandler(response.message)
                        }
                    );
                });

            });
        }

        $scope.$on('json:uploaded', function (event, data, dataString) {
            logger.logSuccess("Uploaded json successfully");
            $scope.analytical_json = dataString;
        });

        $scope.copyAppIdIntoClipoard = function copyAppIdIntoClipoard() {
            Utils.copyToClipboard($scope.app_id);
            $timeout(function () {
                logger.logSuccess("App ID successfully copied into clipboard")
            }, 100);
        }


    }
]);
